<template>
  <v-container>
    <v-card outlined v-if="value.type===1">
      <v-card-text>
        <v-row>
          <v-col cols="11">
            <v-select
                disabled
                :label="value.title"
                :items="value.items"
                return-object
                item-value="id"
                item-text="value"
                :value="value.selected?value.selected:null"
                @input="field_change"
            >
            </v-select>
          </v-col>
          <v-col cols="1"
                 @click="$store.commit('open_edit_selection_dialog', {items: value.items, label: value.title, field_id: value.id})">
            <v-icon class="pt-5">
              mdi-pencil-box-outline
            </v-icon>
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>

    <v-row v-if="value.type===2">
      <v-col cols="11">
        <TagManager :label="value.title" disabled/>
      </v-col>
      <v-col cols="1" @click="$store.commit('open_edit_tag_dialog', {label: value.title, field_id: value.id})">
        <v-icon class="pt-5">
          mdi-pencil-box-outline
        </v-icon>
      </v-col>
    </v-row>

    <v-card outlined v-if="value.type===3">
      <v-card-text>
        <v-row>
          <v-col cols="11">
            <v-textarea
                disabled
                :value="value.value?value.value:null"
                outlined
                :label="value.title"
                @input="field_change"
            >
            </v-textarea>
          </v-col>
          <v-col cols="1" @click="$store.commit('open_edit_text_dialog', {label: value.title, field_id: value.id})">
            <v-icon class="pt-5">
              mdi-pencil-box-outline
            </v-icon>
          </v-col>

        </v-row>
      </v-card-text>
    </v-card>
  </v-container>

</template>

<script>
import TagManager from "./TagManager";

export default {
  name: "FieldEditable",
  components: {TagManager},
  props: ['value'],
  methods: {
    field_change(new_val) {
      this.$emit('field_change', {"old_object": this.value, "new_value": new_val})
    }
  }

}
</script>

<style scoped>

</style>
